module.exports = __webpack_public_path__ + "img/amerigo-measuring.c309c839.jpg";